interface ClerkSignUpErrorLike {
  code?: string;
  message?: string;
}

/**
 * True when Clerk rejected sign-up because the email is already
 * registered — the shell-account claim branch on /signup.
 */
export function isClerkIdentifierExistsError(
  error: ClerkSignUpErrorLike | null | undefined
): boolean {
  if (!error) return false;
  if (error.code === 'form_identifier_exists') return true;
  const message = error.message ?? '';
  return /identifier.*(exists|taken)|email address is taken/i.test(message);
}
